exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-14f29b5a] .el-table__header th {\n  padding: 0;\n  height: 40px;\n  line-height: 50px;\n  text-align: left;\n  background: rgba(22, 101, 216, 0.05);\n  color: rgb(102, 102, 102);\n}\n[data-v-14f29b5a] .el-table__body tr,[data-v-14f29b5a] .el-table__body td {\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n}", ""]);

// exports
